import _extends from "@babel/runtime/helpers/extends";
import { mergeProps } from './mergeProps';
export var mergeRestProps = (restProps, className, style, events) => {
  return mergeProps(restProps, _extends({
    className,
    style
  }, events));
};
export var proxyRestProps = (restProps, to) => {
  var res = {};
  if (typeof restProps['data-testid'] === 'string') {
    res['data-testid'] = restProps['data-testid'] + '__' + to;
  }
  if (typeof restProps['data-role'] === 'string') {
    res['data-role'] = restProps['data-role'] + '__' + to;
  }
  return res;
};
export var spreadRestProps = (restProps, key) => {
  var res = {};
  if (typeof restProps['data-testid'] === 'string') {
    res['data-testid'] = restProps['data-testid'] + '_' + key;
  }
  if (typeof restProps['data-role'] === 'string') {
    res['data-role'] = restProps['data-role'] + '_' + key;
  }
  res['data-item-key'] = key;
  return res;
};
//# sourceMappingURL=mergeRestProps.js.map